import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { selectCurrentPath, setCurrentPath } from "../../features/userSlice";
import { useSelector } from "react-redux";
import {
  setSelectedComponents,
  setSelectedFeatures,
  setSelectedSharedUid,
  setSelectedSite,
} from "../../features/templateSlice";
import {
  setSelectedFeatures as setSelectedFeaturesTheme,
  setSelectedGroups,
  setSelectedSite as setSelectedSiteTheme,
  setSelectedSharedUid as setSelectedSharedUidTheme,
} from "../../features/themeSlice";
import store from "../../store";
import { setSelectedMetaSearchSite } from "../../features/metaEntitiesSlice";
import {
  setSelectedAsset,
  setSelectedDate,
  setSelectedSource,
} from "../../features/manualExpenseSlice";
import {
  setSelectedAssignee,
  setSelectedCategory,
  setSelectedDueDate,
  setSelectedPriority,
  setSelectedSearchSite,
  setSelectedStatus,
  setSelectedTarget,
} from "../../features/actionItemsSlice";
import {
  setSelectedFilterPopups,
  setSelectedFilterTheme,
  setSelectedSharedUid as setSelectedSharedUidPageGroup,
  setSelectedSite as setSelectedSitePageGroup,
} from "../../features/pageGroupSlice";
import {
  setSelectedAssets,
  setSelectedLabels,
  setSelectedNoteDate,
  setSelectedNotetitle,
  setSelectedStakeholders,
} from "../../features/activityNoteSlice";
import {
  setSelectedAccount,
  setSelectedCompany,
  setSelectedDataCollectionBrands,
  setSelectedRawTableId,
  setSelectedWebsites,
  setSelectedStatus as setSelectedStatusBrands,
  setSelectedInterface,
  setSelectedBrands,
} from "../../features/dataCollectionBrandsSlice";
import {
  setSelectedDatabase,
  setSelectedId,
  setSelectedQueryName,
} from "../../features/dataStoreReqSlice";
import { setSelectedType } from "../../features/websiteActionSlice";
import {
  setSelectedMultiplePackages,
  setSelectedPackage,
  setSelectedPackageBrand,
  setSelectedPackageDateRange,
  setSelectedPackageInterface,
  setSelectedPackageStatus,
  setSelectedProcessName,
} from "../../features/monitoringPackagesSlice";
import {
  setSelectedLogsBrand,
  setSelectedLogsInterface,
  setSelectedLogsPackage,
  setSelectedLogsProcessName,
  setSelectedLogsStatus,
  setSelectedPackageAutoComplete,
  setSelectedPodName,
  setSelectedProcessLogsDateRange,
  setSelectedWorkFlow,
} from "../../features/monitoringProcessLogsSlice";
import {
  setFilteringDefJSONOutput,
  setSelectedDestinationTable,
  setSelectedDestinationTableCreateScreen,
  setSelectedInterfaceCreateScreen,
  setSelectedInterface as setSelectedInterfaceUniqueDef,
  setSelectedUniqueDefDestinationTable,
  setSelectedUniqueDefID,
  setSelectedUniqueDefInterfaceName,
  setUniqueDefinitionData,
} from "../../features/uniqueDefSlice";
import {
  setAssetManagementData,
  setSelectedPage,
  setSitePages,
  setSelectedSite as setSelectedSiteAssetManagement,
  setSelectedOptionGroup,
  setSelectedOptionStatus,
  setPageDetails,
} from "../../features/assetManagementSlice";
import {
  setDataSet,
  setFetchBy,
  setOrganizationDimensions,
  setOrganizationOptions,
  setSelectedEndDate,
  setSelectedStartDate,
  setTrendsDashboardExecuteQueriesData,
  setSelectedSharedUid as setSelectedSharedUidTrends,
  clearTrendsFilters,
  setCountryDataTrendsBreakdown,
  setTrafficSourceDataTrendsBreakdown,
  setCampaignDataTrendsBreakdown,
  setAdGroupDataTrendsBreakdown,
  setKeywordMatchTypeDataTrendsBreakdown,
  setBrandsDataTrendsBreakdown,
  setInCampaignBD,
  setSelectedKeyword,
  setSelectedMatchTypeFilterBD,
  setSelectedCampaignFilterBD,
  setSelectedAdGroupFilterBD,
  setSelectedTrafficSourceFilterBD,
  setSelectedSearchBrand,
} from "../../features/trendsSlice";
import dayjs from "dayjs";
import {
  setAllAdvertisingAccounts,
  setAllCampaigns,
  setCostWeightchartData,
  setLpLoader,
  setPerformanceByKeywords,
  setRelevantAccountsBasedOnSite,
  setSelectedLPAccount,
  setSelectedLPCampaign,
  setSelectedLPDateRange,
  setSelectedLPSharedUid,
  setSiteDimensions,
} from "../../features/landingPageExperienceSlice";

import {
  setSelectedSharedUid as setSelectedSharedUidPageSpeedPerformance,
  setDevice as setDevicePageSpeedPerformance,
  setSelectedInterval,
  setSelectedPriode,
} from "../../features/pageSpeedPerformanceSlice";

const RouteTracker = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentPath = useSelector(selectCurrentPath).split("/");

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("templates")) {
      store.dispatch(setSelectedFeatures(null));
      store.dispatch(setSelectedComponents(null));
      store.dispatch(setSelectedSite(null)); // Reset selectedSite when leaving the templates page()
      store.dispatch(setSelectedSharedUid(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("meta_entities")) {
      store.dispatch(setSelectedMetaSearchSite(null)); // Reset selectedSite when leaving the templates page()
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

   useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_builder")) {
     dispatch(setSitePages([]));
     dispatch(setSelectedOptionGroup([]));
     dispatch(setSelectedOptionStatus([]));
     dispatch(setSelectedDate([]));
     dispatch(setPageDetails([]));
    
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    if (!currentPath.includes("manual_expenses")) {
      store.dispatch(setSelectedAsset(null));
      store.dispatch(setSelectedSource(null));
      store.dispatch(setSelectedDate(null)); // Reset selectedSite when leaving the templates page()
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("theme")) {
      dispatch(setSelectedFeaturesTheme(null));
      dispatch(setSelectedGroups(null));
      dispatch(setSelectedSiteTheme(null)); // Reset selectedSite when leaving the templates page()
      dispatch(setSelectedSharedUidTheme(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("action_items")) {
      dispatch(setSelectedCategory(null));
      dispatch(setSelectedStatus(null));
      dispatch(setSelectedDueDate(null));
      dispatch(setSelectedPriority(null));
      dispatch(setSelectedAssignee(null));
      dispatch(setSelectedTarget(null));
      dispatch(setSelectedSearchSite(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_groups")) {
      dispatch(setSelectedFilterTheme(null));
      dispatch(setSelectedFilterPopups(null));
      dispatch(setSelectedSharedUidPageGroup(null));
      dispatch(setSelectedSitePageGroup(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("activity_notes")) {
      dispatch(setSelectedNotetitle(null));
      dispatch(setSelectedAssets(null));
      dispatch(setSelectedStakeholders(null));
      dispatch(setSelectedNoteDate(null));
      dispatch(setSelectedLabels(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("brands")) {
      dispatch(setSelectedDataCollectionBrands(null));
      dispatch(setSelectedAccount(null));
      dispatch(setSelectedCompany(null));
      dispatch(setSelectedWebsites(null));
      dispatch(setSelectedStatusBrands(null));
      dispatch(setSelectedRawTableId(null));
      dispatch(setSelectedInterface(null));
      dispatch(setSelectedBrands(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("queries")) {
      dispatch(setSelectedQueryName(null));
      dispatch(setSelectedType(null));
      dispatch(setSelectedDatabase(null));
      dispatch(setSelectedId(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("data_workflows")) {
      dispatch(setSelectedPackage(null));
      dispatch(setSelectedMultiplePackages(null));
      dispatch(setSelectedProcessName(null));
      dispatch(setSelectedPackageStatus(null));
      dispatch(setSelectedPackageBrand(null));
      dispatch(setSelectedPackageDateRange(null));
      dispatch(setSelectedPackageInterface(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("data_logs")) {
      dispatch(setSelectedWorkFlow(null));
      dispatch(setSelectedLogsPackage(null));
      dispatch(setSelectedLogsProcessName(null));
      dispatch(setSelectedLogsStatus(null));
      dispatch(setSelectedLogsBrand(null));
      dispatch(setSelectedProcessLogsDateRange(null));
      dispatch(setSelectedLogsInterface(null));
      dispatch(setSelectedPackageAutoComplete(null));
      dispatch(setSelectedPodName(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("unique_definitions")) {
      dispatch(setSelectedInterfaceUniqueDef(null));
      dispatch(setSelectedDestinationTable(null));
      dispatch(setSelectedUniqueDefID([]));
      dispatch(setSelectedUniqueDefInterfaceName([]));
      dispatch(setSelectedUniqueDefDestinationTable([]));
      dispatch(setUniqueDefinitionData([]));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("create_new_definition")) {
      dispatch(setSelectedInterfaceCreateScreen(null));
      dispatch(setSelectedDestinationTableCreateScreen(null));
      dispatch(setFilteringDefJSONOutput(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_management")) {
      store.dispatch(setAssetManagementData(null));
      store.dispatch(setSelectedSiteAssetManagement(null));
      store.dispatch(setSelectedPage(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("trends")) {
      store.dispatch(setFetchBy("site"));
      store.dispatch(setDataSet("click"));
      store.dispatch(setTrendsDashboardExecuteQueriesData([]));
      store.dispatch(setSelectedStartDate(dayjs().startOf("month")));
      store.dispatch(setSelectedEndDate(dayjs().endOf("month")));
      store.dispatch(setOrganizationOptions([]));
      store.dispatch(setOrganizationDimensions([]));
      store.dispatch(setSelectedSharedUidTrends([]));
      store.dispatch(clearTrendsFilters());
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("breakdown")) {
      store.dispatch(setCountryDataTrendsBreakdown([]));
      store.dispatch(setTrafficSourceDataTrendsBreakdown([]));
      store.dispatch(setCampaignDataTrendsBreakdown([]));
      store.dispatch(setAdGroupDataTrendsBreakdown([]));
      store.dispatch(setKeywordMatchTypeDataTrendsBreakdown([]));
      store.dispatch(setBrandsDataTrendsBreakdown([]));
      store.dispatch(setInCampaignBD(null));
      store.dispatch(setSelectedKeyword(null));
      store.dispatch(setSelectedMatchTypeFilterBD(null));
      store.dispatch(setSelectedCampaignFilterBD(null));
      store.dispatch(setSelectedAdGroupFilterBD(null));
      store.dispatch(setSelectedTrafficSourceFilterBD(null));
      store.dispatch(setSelectedSearchBrand(null));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("landing_page_experience")) {
      dispatch(setSelectedLPSharedUid(""));
      dispatch(setSelectedLPAccount(""));
      dispatch(setSelectedLPDateRange([]));
      dispatch(setSelectedLPCampaign(""));
      dispatch(setAllAdvertisingAccounts([]));
      dispatch(setRelevantAccountsBasedOnSite([]));
      dispatch(setAllCampaigns([]));
      dispatch(setCostWeightchartData([]));
      dispatch(setPerformanceByKeywords([]));
      dispatch(setLpLoader(false));
      dispatch(setSiteDimensions([]));
    }
    // eslint-disable-next-line
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(setCurrentPath(location.pathname)); // Update Redux store with new path
    if (!currentPath.includes("page_speed_performance")) {
      dispatch(setSelectedSharedUidPageSpeedPerformance(null));
      dispatch(setDevicePageSpeedPerformance({ label: "Mobile" }));
      dispatch(setSelectedInterval({ label: "Month", value: "month" }));
      // dispatch(
      //   setQuarter({
      //     label: null,
      //     startMonth: null,
      //     endMonth: null,
      //   })
      // );
      dispatch(setSelectedPriode(dayjs()));
    }
    // eslint-disable-next-line
  }, [location]);

  return null; // No UI needed, just tracking route changes
};

export default RouteTracker;
